import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";

export default function StripeCardSetup({
  setupSession,
  onSucceeded,
  freeBooking = false,
  // Set when there is no load in play — the standing payment link (CIN-1203),
  // where both booking-scoped sentences below would be wrong.
  subtitle = null,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!stripe || !elements) return;
    setError("");
    setBusy(true);
    try {
      const card = elements.getElement(CardElement);
      const result = await stripe.confirmCardSetup(setupSession.client_secret, {
        payment_method: { card },
      });
      if (result.error) {
        setError(result.error.message || "Card could not be saved.");
        setBusy(false);
        return;
      }
      onSucceeded();
    } catch (e) {
      setError(e?.message || "Something went wrong.");
      setBusy(false);
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-[480px] bg-white rounded-2xl shadow-md p-7"
    >
      <h1 className="text-[22px] font-bold tracking-tight text-slate-900 mb-1.5">
        Add your card
      </h1>
      <p className="text-sm text-slate-500 mb-4">
        {subtitle ||
          (freeBooking
            ? "This load is free — your card won't be charged for it. We keep it on file for future loads."
            : "You will only be charged upon successful booking of the load.")}
      </p>
      <div className="border border-slate-300 rounded-xl px-4 py-3.5 mb-4 bg-white focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-200">
        <CardElement options={{ hidePostalCode: false }} />
      </div>
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg px-3.5 py-2.5 text-sm mb-3 leading-snug">
          {error}
        </div>
      )}
      <button
        type="submit"
        disabled={busy || !stripe}
        className="w-full !shadow-none !bg-indigo-600 hover:!bg-indigo-700 !text-white !border-0 !rounded-xl !px-4 !py-3.5 !text-[15px] !font-semibold disabled:opacity-55 disabled:cursor-not-allowed"
      >
        {busy ? "Saving…" : "Save card"}
      </button>
    </form>
  );
}
